exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2b6cOasWAwQRpdeM3UKWzk{border:3px solid #c8e6dc;border-radius:50%;display:flex;justify-content:center;align-items:center;margin-right:10px}._2b6cOasWAwQRpdeM3UKWzk span{color:#757575}\n", ""]);

// Exports
exports.locals = {
	"CircledIcon": "_2b6cOasWAwQRpdeM3UKWzk"
};